export function compareByDate(a, b) {
    return new Date(b.date) - new Date(a.date);
}

export function compareByDateAndTime(a, b) {
    // prevOrders.sort((a, b) => a.time.localeCompare(b.time)))
    const dateComparison = new Date(b.date) - new Date(a.date);
    if (dateComparison === 0) {
        return a.time.localeCompare(b.time);
    }
    return dateComparison;
}

export function sortByTimeAndCreatedAt(a, b) {
    const timeComparison = a.time.localeCompare(b.time);
    if (timeComparison !== 0) {
        return timeComparison;
    }
    // If times are equal, sort by createdAt (earlier createdAt comes first)
    // return new Date(a.createdAt) - new Date(b.createdAt);
const aCreated = a.createdAt ? new Date(a.createdAt) : null;
  const bCreated = b.createdAt ? new Date(b.createdAt) : null;

  // Handle nulls — null createdAt goes LAST
  if (!aCreated && bCreated) return 1;
  if (aCreated && !bCreated) return -1;
  if (!aCreated && !bCreated) return 0;

  return aCreated - bCreated;
}

export function formatDateInSpanish(dateString) {
    const date = new Date(dateString);
    const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return adjustedDate.toLocaleDateString('es-ES', options);
}

export function todayDateFormatted() {
    const today = new Date();
    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    return today.toLocaleDateString('es-MX', options);
}